/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import './src/scss/main.scss'

import SmoothScroll from 'smooth-scroll'

import { start } from './src/lib/effects'

const LINK_SELECTOR = 'a[href*="#"]'
new SmoothScroll(LINK_SELECTOR, {
  speed: 1100,
  speedAsDuration: true,
})

start()
